import React from "react";

import CategoryDetailData from "../../js/categoryDetailData";
import {
  Animatespin,
  Navbar,
  MainHeading,
  Experience,
  Footer,
  CategoryDetailCom,
} from "../../components";
import localimgpath from "../../js/localimgpath";
import Functions from "./index.function.js";
const Category = () => {
  const { isLoading, Singlecategor, handleTalent } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Category Detail"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            <div className="flex justify-center items-center">
              <h2 className="text-secondary font-unboundedBold lg:text-2xl xl:text-3xl">
                {Singlecategor?.title} List
              </h2>
            </div>
            {Singlecategor?.talent?.length < 1 ? (
              <div className="text-center pt-5">
                <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm w-full">
                  No talent found
                </p>
              </div>
            ) : (
              <div className="xs:pt-5 sm:pt-5 lg:pt-8 xs:flex xs:justify-center xs:items-start xs:flex-wrap xs:gap-y-5 sm:grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-2 md:gap-4 lg:gap-5 2xl:gap-8">
                {Singlecategor?.talent?.map((value, index) => (
                  <div key={index}>
                    <CategoryDetailCom
                      onClick={() => handleTalent(value?.id)}
                      latestNewsthubmail={`${localimgpath?.talentThumbnail}/${value?.hero_image}`}
                      latestNewsTitle={value?.real_name}
                      alt={value?.stage_name}
                      position={value?.news_title}
                      bgcolor={
                        CategoryDetailData[index % CategoryDetailData?.length]
                          .bgcolor
                      }
                    />
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      <div className="xs:pt-4">
        <Experience />
      </div>
      <Footer />
    </div>
  );
};

export default Category;
